import { lazy } from "react";

export const publicRoutes = [
  {
    path: "/signin",
    exact: true,
    component: lazy(() => import("@screens/Auth/SignIn")),
  },
  {
    path: "/404",
    exact: true,
    component: lazy(() => import("@screens/404/404")),
  },
  {
    path: "/500",
    exact: true,
    component: lazy(() => import("@screens/404/404")),
  },
];

export const privateRoutes = [
  {
    name: "feed",
    path: "/",
    ability: null,
    exact: true,
    component: lazy(() => import("@screens/Feed/index")),
  },
  {
    name: "users.list",
    path: "/usuarios/lista",
    ability: "user.index",
    exact: true,
    component: lazy(() => import("@screens/User")),
  },
  {
    name: "users.create",
    path: "/usuarios/criar",
    ability: "admin",
    exact: true,
    component: lazy(() => import("@screens/User/create")),
  },
  {
    name: "companies.list",
    path: "/empresas/lista",
    ability: "admin",
    exact: true,
    component: lazy(() => import("@screens/Company")),
  },
  {
    name: "companies.create",
    path: "/empresas/criar",
    ability: "admin",
    exact: true,
    component: lazy(() => import("@screens/Company/create")),
  },
  {
    name: "companies.update",
    path: "/empresa/:id",
    ability: "admin",
    exact: true,
    component: lazy(() => import("@screens/Company/update")),
  },
  {
    name: "users.update",
    path: "/usuario/:id",
    ability: "admin",
    exact: true,
    component: lazy(() => import("@screens/User/update")),
  },
  {
    name: "cash_conciliation",
    path: "/cash-conciliation",
    ability: "cash-conciliation",
    exact: true,
    component: lazy(() => import("@screens/CashConciliation/index")),
  },
  {
    name: "cash_conciliation.transactions",
    path: "/cash-conciliation/:id",
    ability: "cash-conciliation",
    exact: true,
    component: lazy(() => import("@screens/CashConciliation/transactions")),
  },
  {
    name: "cash_conciliation.close.checkout",
    path: "/cash-conciliation/:id/close-checkout/:solicitation?",
    ability: "cash-conciliation",
    exact: true,
    component: lazy(() => import("@screens/CashConciliation/checkout")),
  },
  {
    name: "manual-transactions",
    path: "/cash-conciliation/:id/manual-transactions/:date?",
    ability: "cash-conciliation.solicitation",
    exact: true,
    component: lazy(() =>
      import("@screens/CashConciliation/manualTransactions")
    ),
  },
  {
    name: "diff-transactions",
    path: "/cash-conciliation/:id/diff-transactions/:date/:lastSolicitation?",
    ability: "cash-conciliation.solicitation",
    exact: true,
    component: lazy(() => import("@screens/CashConciliation/diffTransactions")),
  },
  {
    name: "fuel-nozzle.list",
    path: "/bicos-combustivel",
    ability: "fuel-nozzle.actions",
    exact: true,
    component: lazy(() => import("@screens/FuelNozzle/index")),
  },
  {
    name: "fuel-nozzle.create",
    path: "/bicos-combustivel/criar",
    ability: "fuel-nozzle.actions",
    exact: true,
    component: lazy(() => import("@screens/FuelNozzle/create")),
  },
  {
    name: "cash-conciliation-solicitation.list-conferences",
    path: "/cash-conciliation/solicitation/conferences",
    ability: "cash-conciliation.solicitation",
    exact: true,
    component: lazy(() =>
      import("@screens/CashConciliation/Solicitation/Conference/index")
    ),
  },
  {
    name: "cash-conciliation-solicitation-protheus",
    path: "/cash-conciliation-protheus",
    ability: "cash-conciliation-protheus",
    exact: true,
    component: lazy(() =>
      import("@screens/CashConciliationProtheus/index")
    ),
  },
  {
    name: "cash-conciliation-protheus-cash-consult",
    path: "/cash-conciliation-protheus/cash-consult",
    ability: ["admin", "cash-conciliation-protheus"],
    exact: true,
    component: lazy(() =>
      import("@screens/CashConciliationProtheus/CashConsultScreen/index")
    ),
  },
  {
    name: "cash-conciliation-protheus-review",
    path: "/cash-conciliation-protheus/review/:companyId/:date",
    ability: "cash-conciliation-protheus",
    exact: true,
    component: lazy(() =>
      import("@screens/CashConciliationProtheus/ReviewCashScreen/index")
    ),
  },
  {
    name: "cash-conciliation-protheus-transactions",
    path: "/transaction-conciliation/transactions_consult",
    ability: "cash-conciliation.consult-transactions",
    exact: true,
    component: lazy(() =>
      import("@screens/CashConciliationProtheus/TransactionConsult/index")
    ),
  },
  {
    name: "cash-conciliation-protheus-adjust",
    path: "/cash-conciliation-protheus/adjust/:companyId/:date/:pdv/:turno/:operatorCode",
    ability: "cash-conciliation-protheus",
    exact: true,
    component: lazy(() =>
      import("@screens/CashConciliationProtheus/AdjustCashScreen/index")
    ),
  },
  {
    name: "cash-conciliation-protheus-audit-approval",
    path: "/cash-conciliation-protheus/audit-approval",
    ability: ["cash-conciliation.audit-approval", "financial.audit-approval"],
    exact: true,
    component: lazy(() =>
      import("@screens/CashConciliationProtheus/AuditApprovalScreen/index")
    ),
  },
  {
    name: "cash-conciliation-protheus-adjustment-integration",
    path: "/cash-conciliation-protheus/adjustment-integration",
    ability: ["financial.integrate"],
    exact: true,
    component: lazy(() =>
      import("@screens/CashConciliationProtheus/AdjustmentIntegrationScreen/index")
    ),
  },
  {
    name: "cash-conciliation-protheus-cash-summary",
    path: "/cash-conciliation-protheus/cash-summary/:companyId/:date",
    ability: "cash-conciliation-protheus",
    exact: true,
    component: lazy(() =>
      import("@screens/CashConciliationProtheus/CashSummaryScreen/index")
    ),
  },
  {
    name: "cash-conciliation-protheus-cash-summary-shift",
    path: "/cash-conciliation-protheus/cash-summary/:companyId/:date/:pdv/:shift/:operatorCode",
    ability: "cash-conciliation-protheus",
    exact: true,
    component: lazy(() =>
      import("@screens/CashConciliationProtheus/CashSummaryShiftScreen/index")
    ),
  },
  {
    name: "employees",
    path: "/funcionarios",
    ability: "employees",
    exact: true,
    component: lazy(() =>
      import("@screens/CashConciliationProtheus/EmployeesScreen/index")
    ),
  },
  {
    name: "cash-conciliation-protheus-ranking",
    path: "/cash-conciliation-protheus/ranking",
    ability: "cash-conciliation.ranking",
    exact: true,
    component: lazy(() =>
      import("@screens/CashConciliationProtheus/RankingScreen/index")
    ),
  },
  {
    name: "file-transaction-templates",
    path: "/file-transaction-templates",
    ability: "financial.conciliation-params",
    exact: true,
    component: lazy(() =>
      import("@screens/FileTransactionTemplates/index")
    ),
  },
  {
    name: "cash-conciliation-solicitation.inconsistent-transactions",
    path: "/cash-conciliation/solicitation/:date/inconsistent-transactions",
    ability: "cash-conciliation.solicitation",
    exact: true,
    component: lazy(() =>
      import(
        "@screens/CashConciliation/Solicitation/InconsistentTransactionModal/index"
      )
    ),
  },
  {
    name: "cash-conciliation-solicitation.checkout",
    path: "/cash-conciliation/solicitation/:date/checkout/:solicitation?",
    ability: "cash-conciliation.solicitation",
    exact: true,
    component: lazy(() =>
      import("@screens/CashConciliation/Solicitation/Checkout/index")
    ),
  },
  {
    name: "cash-conciliation-solicitation.pending",
    path: "/cash-conciliation/solicitation/pending",
    ability: "cash-conciliation.solicitation.analyze",
    exact: true,
    component: lazy(() =>
      import("@screens/CashConciliation/Solicitation/Pending/index")
    ),
  },
  {
    name: "cash-conciliation-solicitation.show",
    path: "/cash-conciliation-solicitation/:id",
    ability: "cash-conciliation.solicitation",
    exact: true,
    component: lazy(() =>
      import("@screens/CashConciliation/Solicitation/Single/index")
    ),
  },
  {
    name: "cash-conciliation.movement-reason-map",
    path: "/cash-conciliation-movement-reason-map",
    ability: "cash-conciliation",
    exact: true,
    component: lazy(() =>
      import("@screens/CashConciliation/MovementReasonMap/index")
    ),
  },
  {
    name: "integration.events",
    path: "/integration/dominio-setup",
    ability: "dominio-integration",
    exact: true,
    component: lazy(() =>
      import("@screens/Integration/DominioAutoSystem/index")
    ),
  },
  {
    name: "integration.rm-mapping",
    path: "/integration/rm-mapping",
    ability: "rm.mappings",
    exact: true,
    component: lazy(() =>
      import("@screens/Integration/rm/RmMapping")
    ),
  },
  {
    name: "integration.rm-payroll-sync",
    path: "/integration/rm-payroll-sync",
    ability: "rm.mappings",
    exact: true,
    component: lazy(() =>
      import("@screens/Integration/rm/PayrollSync")
    ),
  },
  {
    name: "integration.rm-payroll-integration",
    path: "/integration/rm-payroll-integration",
    ability: "rm.mappings",
    exact: true,
    component: lazy(() =>
      import("@screens/Integration/rm/PayrollIntegration")
    ),
  },
  {
    name: "integration.rm-reconciliation",
    path: "/integration/rm-reconciliation",
    ability: "rm.integration-reconciliation",
    exact: true,
    component: lazy(() =>
      import("@screens/Integration/rm/IntegrationReconciliation")
    ),
  },
  {
    name: "integration.protheus.accounts-receivable",
    path: "/integration/protheus/accounts-receivable",
    ability: "protheus.accounts-receivable",
    exact: true,
    component: lazy(() =>
      import("@screens/Integration/Protheus/index")
    ),
  },
  {
    name: "financial.borderos",
    path: "/financial/borderos",
    ability: "financial.borderos",
    exact: true,
    component: lazy(() => import("@screens/Financial/Bordero/index")),
  },
  {
    name: "financial.acquirer-transactions",
    path: "/financial/acquirer-transactions",
    ability: "financial.acquirer-transactions",
    exact: true,
    component: lazy(() => import("@screens/Financial/AcquirerTransactions/index")),
  },
  {
    name: "financial.bank.balance",
    path: "/financial/bank/balance",
    ability: "financial.bank-balances",
    exact: true,
    component: lazy(() => import("@screens/Financial/BankBalance/index")),
  },
  {
    name: "fiscal.sage-integration",
    path: "/fiscal/sage-integration",
    ability: "fiscal.sage-integration",
    exact: true,
    component: lazy(() => import("@screens/Fiscal/SageIntegration/index")),
  },
  {
    name: "fiscal.sage-integration",
    path: "/fiscal/sage-integration/movement-types",
    ability: "fiscal.sage-integration",
    exact: true,
    component: lazy(() => import("@screens/Fiscal/SageIntegration/movementTypes")),
  },
  {
    name: "smart-pos-terminal.list",
    path: "/smart-pos-terminal",
    ability: "smart-pos-terminal",
    exact: true,
    component: lazy(() => import("@screens/SmartPosTerminal/index")),
  },
  {
    name: "tasks.list",
    path: "/tasks/list",
    ability: "task-flow.tasks",
    exact: true,
    component: lazy(() => import("@screens/Task/index")),
  },
  {
    name: "tasks.create",
    path: "/tasks/create",
    ability: "task-flow.tasks",
    exact: true,
    component: lazy(() => import("@screens/Task/create")),
  },
  {
    name: "tasks.update",
    path: "/tasks/:id",
    ability: "task-flow.tasks",
    exact: true,
    component: lazy(() => import("@screens/Task/update")),
  },
  {
    name: "task-groups.list",
    path: "/task-groups/list",
    ability: "task-flow.tasks",
    exact: true,
    component: lazy(() => import("@screens/TaskGroup/index")),
  },
  {
    name: "task-groups.create",
    path: "/task-groups/create",
    ability: "task-flow.tasks",
    exact: true,
    component: lazy(() => import("@screens/TaskGroup/create")),
  },
  {
    name: "task-groups.update",
    path: "/task-groups/:id",
    ability: "task-flow.tasks",
    exact: true,
    component: lazy(() => import("@screens/TaskGroup/update")),
  },
  {
    name: "my-tasks",
    path: "/my-tasks",
    ability: "task-flow.my-tasks",
    exact: true,
    component: lazy(() => import("@screens/MyTask/index")),
  },
  {
    name: "Etiquetas",
    path: "/etiquetas",
    ability: "labels",
    exact: true,
    component: lazy(() => import("@screens/ShelfLabels/index")),
  },
  {
    name: "cash-conciliation.movement-type",
    path: "/movement-type",
    ability: "cash-conciliation.movement-type",
    exact: true,
    component: lazy(() =>
      import("@screens/CashConciliation/MovementType/index")
    ),
  },
  {
    name: "cash-conciliation.movement-type",
    path: "/movement-type-v2",
    ability: "cash-conciliation.movement-type",
    exact: true,
    component: lazy(() =>
      import("@screens/CashConciliation/MovementType/indexV2")
    ),
  },
  {
    name: "financial.download-transactions",
    path: "/financial/download-transactions",
    ability: "financial.download-transactions",
    exact: true,
    component: lazy(() => import("@screens/Financial/DownloadTransactions/index")),
  },
  {
    name: "financial.bank-account-statements",
    path: "/financial/bank-account-statements",
    ability: "financial.conciliation-params",
    exact: true,
    component: lazy(() => import("@screens/Financial/BankAccountStatements/index")),
  },
  {
    name: 'card-conciliation.list',
    path: '/card-conciliation',
    ability: 'financial.card-conciliation',
    exact: true,
    component: lazy(() => import('@screens/CardConciliation/index')),
  },
  {
    name: 'transaction-conciliation.list',
    path: '/transaction-conciliation',
    exact: true,
    ability: 'financial.conciliation-params',
    component: lazy(() => import('@screens/TransactionConciliation/index')),
  },
  {
    name: 'transaction-conciliation.list',
    path: '/transaction-conciliation-V2',
    exact: true,
    ability: 'financial.conciliation-params',
    component: lazy(() => import('@screens/TransactionConciliation/indexV2')),
  },
  {
    name: 'transaction-conciliation.config',
    path: '/transaction-conciliation/config',
    exact: true,
    ability: 'financial.conciliation-params',
    component: lazy(() => import('@screens/TransactionConciliation/ConciliationConfig')),
  },
  {
    name: 'transaction-conciliation.acquirer_mappings',
    path: '/transaction-conciliation/acquirer_mappings',
    exact: true,
    ability: 'financial.conciliation-params',
    component: lazy(() => import('@screens/TransactionConciliation/AcquirerMappings/index')),
  },
  {
    name: 'transaction-conciliation.inconsistencies',
    path: '/transaction-conciliation/inconsistencies',
    exact: true,
    ability: 'financial.conciliation-params',
    component: lazy(() => import('@screens/TransactionConciliation/ConciliationInconsistencies')),
  },
  {
    name: "column-mapping",
    path: "/financial-transactions/setting/column-mapping",
    ability: "setting-column-mapping",
    exact: true,
    component: lazy(() => import("@screens/Financial/ColumnMapping/Mapping/index")),
  },
  {
    name: "column-mapping",
    path: "/financial-transactions/column-mapping/import",
    ability: "import-file-column-mapping",
    exact: true,
    component: lazy(() => import("@screens/Financial/ColumnMapping/Import/index")),
  },
  {
    name: "purchases-order.list",
    path: "/compras/pedido/lista",
    ability: "purchases.purchase-orders",
    exact: true,
    component: lazy(() => import("@screens/Purchase/PurchaseOrder/index")),
  },
  {
    name: "purchases-order.products",
    path: "/compras/pedido/produtos",
    ability: "purchases.purchase-orders",
    exact: true,
    component: lazy(() => import("@screens/Purchase/PurchaseOrder/index")),
  },
  {
    name: "purchases-order.fuel",
    path: "/compras/pedido/combustiveis",
    ability: "purchases.purchase-orders",
    exact: true,
    component: lazy(() => import("@screens/Purchase/PurchaseOrder/index")),
  },
  {
    name: "purchases-order.create",
    path: "/compras/pedido/criar",
    ability: "purchases.purchase-orders",
    exact: true,
    component: lazy(() => import("@screens/Purchase/PurchaseOrder/create")),
  },
  {
    name: "purchases-order.create-fuel",
    path: "/compras/pedido/criar/combustivel",
    ability: "purchases.purchase-orders",
    exact: true,
    component: lazy(() => import("@screens/Purchase/PurchaseOrder/createFuel")),
  },
  {
    name: "purchases.price-margin-analysis",
    path: "/compras/margem-preco",
    ability: "purchases.purchase-orders",
    exact: true,
    component: lazy(() => import("@screens/Purchase/PriceMarginAnalysis/index")),
  },
  {
    name: "truck.list",
    path: "/caminhoes/lista",
    ability: "purchases.purchase-orders",
    exact: true,
    component: lazy(() => import("@screens/Truck/index")),
  },
  {
    name: "truck.create",
    path: "/caminhoes/criar",
    ability: "purchases.purchase-orders",
    exact: true,
    component: lazy(() => import("@screens/Truck/create")),
  },
  {
    name: "driver.list",
    path: "/motoristas/lista",
    ability: "purchases.purchase-orders",
    exact: true,
    component: lazy(() => import("@screens/Driver/index")),
  },
  {
    name: "driver.create",
    path: "/motoristas/criar",
    ability: "purchases.purchase-orders",
    exact: true,
    component: lazy(() => import("@screens/Driver/create")),
  },
  {
    name: "truck.list",
    path: "/caminhoes/lista",
    ability: "purchases.purchase-orders",
    exact: true,
    component: lazy(() => import("@screens/Truck/index")),
  },
  {
    name: "truck.create",
    path: "/caminhoes/criar",
    ability: "purchases.purchase-orders",
    exact: true,
    component: lazy(() => import("@screens/Truck/create")),
  },
  {
    name: "settlement-account",
    path: "/contas-liquidacao",
    ability: "settlement-account",
    exact: true,
    component: lazy(() => import("@screens/SettlementAccount/index")),
  },
  {
    name: "statements",
    path: "/financial/statements",
    ability: "financial.statements",
    exact: true,
    component: lazy(() => import("@screens/Financial/Statements/index")),
  },
  {
    name: "attachments",
    path: "/attachments",
    ability: "attachment",
    exact: true,
    component: lazy(() => import("@screens/CashConciliation/Attachment/index")),
  },
  {
    name: "acquirer-company",
    path: "/adquirente-empresa",
    ability: "acquirer-company",
    exact: true,
    component: lazy(() => import("@screens/AcquirerCompany/index")),
  },
  {
    name: "financial.system-movements",
    path: "/financial/system-movements",
    ability: "financial.system-movements",
    exact: true,
    component: lazy(() => import("@screens/SystemMovement/SystemMovements/index")),
  },
  {
    name: "budget.list",
    path: "/budget/list",
    ability: "budget",
    exact: true,
    component: lazy(() => import("@screens/Budget")),
  },
  {
    name: 'integration-control',
    path: '/integration-control',
    ability: "integration-control",
    exact: true,
    component: lazy(() => import('@screens/IntegrationControl/index'))
  },
  {
    name: 'integration-mappings',
    path: '/integration-mappings',
    ability: "integration-mappings",
    exact: true,
    component: lazy(() => import('@screens/IntegrationMappings/index'))
  },
  {
    name: 'bank-slip',
    path: '/bank-slips',
    ability: 'financial.bank-slip',
    exact: true,
    component: lazy(() => import('@screens/Financial/BankSlip/index'))
  },
  {
    name: 'product-workflow',
    path: '/product-workflow',
    ability: 'workflow.products',
    exact: true,
    component: lazy(() => import('@screens/ProductWorkflow/index'))
  },
  {
    name: 'solicitation-central',
    path: '/solicitation-central',
    ability: 'workflow.solicitations',
    exact: true,
    component: lazy(() => import('@screens/SolicitationCentral/index'))
  },
  {
    name: 'buy-solicitation',
    path: '/solicitation-central/buy-solicitation',
    ability: 'workflow.solicitations',
    exact: true,
    component: lazy(() => import('@screens/SolicitationCentral/buySolicitation'))
  },
  {
    name: 'service-solicitation',
    path: '/solicitation-central/service-solicitation',
    ability: 'workflow.solicitations',
    exact: true,
    component: lazy(() => import('@screens/SolicitationCentral/serviceSolicitation'))
  },
  {
    name: 'payment-solicitation',
    path: '/solicitation-central/payment-solicitation',
    ability: 'workflow.solicitations',
    exact: true,
    component: lazy(() => import('@screens/SolicitationCentral/paymentSolicitation'))
  },
  {
    name: 'product-workflow-new',
    path: '/product-workflow/new',
    exact: true,
    ability: 'workflow.products',
    component: lazy(() => import('@screens/ProductWorkflow/tableProduct'))
  },
  {
    name: 'product-workflow-id',
    path: '/product-workflow/:id/edit',
    ability: 'workflow.products',
    exact: true,
    component: lazy(() => import('@screens/ProductWorkflow/tableProduct'))
  },
  {
    name: 'product-workflow-id',
    path: '/product-workflow/:id/show',
    ability: 'workflow.products',
    exact: true,
    component: lazy(() => import('@screens/ProductWorkflow/tableProduct'))
  },
  {
    name: "fuel-cost",
    path: "/custo-combustivel",
    ability: "fuel-cost",
    exact: true,
    component: lazy(() => import("@screens/FuelCost")),
  },
  {
    name: 'workflow',
    path: '/workflow',
    ability: 'workflow',
    exact: true,
    component: lazy(() => import('@screens/Workflow/index'))
  },
  {
    name: "company-module-list",
    path: "/modulos-empresa/lista",
    ability: "admin",
    exact: true,
    component: lazy(() => import("@screens/CompanyModule/index")),
  },
  {
    name: "company-module-create",
    path: "/modulos-empresa/criar",
    ability: "admin",
    exact: true,
    component: lazy(() => import("@screens/CompanyModule/create")),
  },
  {
    name: "company-module-update",
    path: "/modulos-empresa/:id",
    ability: "admin",
    exact: true,
    component: lazy(() => import("@screens/CompanyModule/update")),
  },
  {
    name: "supplier-products-price/list",
    path: "/fornecedores-produtos/lista",
    ability: "purchases.purchase-orders",
    exact: true,
    component: lazy(() => import("@screens/SupplierProductsPrice/index")),
  },

  {
    name: "supplier-company/list",
    path: "/fornecedores-empresas/lista",
    ability: "purchases.purchase-orders",
    exact: true,
    component: lazy(() => import("@screens/SupplierCompany/index")),
  },
  {
    name: "cost-center-update",
    path: "/cost-center-update",
    ability: "admin",
    exact: true,
    component: lazy(() => import("@screens/SolicitationCentral/update")),
  },
  {
    name: "permissions.management",
    path: "/gestao-permissoes",
    ability: "admin",
    exact: true,
    component: lazy(() => import("@screens/PermissionManagement/index")),
  },
  {
    name: "acquirer",
    path: "/adquirentes",
    ability: "admin",
    exact: true,
    component: lazy(() => import("@screens/Acquirer/index")),
  },
  {
    name: "acquirer-credentials",
    path: "/credenciais-adquirentes",
    ability: "acquirer-credentials",
    exact: true,
    component: lazy(() => import("@screens/AcquirerCredentials/index")),
  },
  {
    name: "system-settings",
    path: "/configuracoes-sistema",
    ability: "system-settings",
    exact: true,
    component: lazy(() => import("@screens/SystemSettings/index")),
  },
  {
    name: "technical-documentation",
    path: "/documentacao-tecnica",
    ability: "technical-documentation",
    exact: true,
    component: lazy(() => import("@screens/TechnicalDocumentation/index")),
  },
  {
    name: "user-guide",
    path: "/guia-usuario",
    ability: "user-guide",
    exact: true,
    component: lazy(() => import("@screens/UserGuide/index")),
  },
  {
    name: "routines",
    path: "/routines",
    ability: "admin",
    exact: true,
    component: lazy(() => import("@screens/Routines/index")),
  },
  {
    name: "campaign-management",
    path: "/configuracao-campanhas",
    ability: "campaign-management",
    exact: true,
    isMobile: true,
    component: lazy(() => import("@screens/CampaignManagement/index")),
    mobileComponent: lazy(() => import("@screens/Mobile/CampaignManagement/index")),
  },
  {
    name: "campaign-results",
    path: "/resultados-campanhas",
    ability: "campaign-results",
    exact: true,
    component: lazy(() => import("@screens/CampaignManagement/ResultsPanel")),
  },
  {
    name: "price-check",
    path: "/price-check",
    ability: 'price-check',
    exact: true,
    isMobile: true,
    component: lazy(() => import("@screens/ShelfLabels/index")),
    mobileComponent: lazy(() => import("@screens/Mobile/PriceCheck/index")),
  },
  {
    name: "receiving",
    path: "/recebimento",
    ability: "receiving",
    exact: true,
    isMobile: true,
    component: lazy(() => import("@screens/Receiving/index")),
    mobileComponent: lazy(() => import("@screens/Mobile/Receiving/EntryDocument")),
  },
  {
    name: "receiving.verification",
    path: "/recebimento/:id/verificacao",
    ability: "receiving",
    exact: true,
    isMobile: true,
    component: lazy(() => import("@screens/Receiving/ItemVerification")),
    mobileComponent: lazy(() => import("@screens/Mobile/Receiving/ItemVerification")),
  },
  {
    name: "receiving.finalization",
    path: "/recebimento/:id/finalizacao",
    ability: "receiving",
    exact: true,
    isMobile: true,
    component: lazy(() => import("@screens/Receiving/Finalization")),
    mobileComponent: lazy(() => import("@screens/Mobile/Receiving/Finalization")),
  },
  {
    name: "receiving.tracking",
    path: "/recebimento/acompanhamento",
    ability: "receiving",
    exact: true,
    isMobile: true,
    component: lazy(() => import("@screens/Receiving/Tracking/index")),
  },
  {
    name: "receiving.tracking.detail",
    path: "/recebimento/acompanhamento/:id",
    ability: "receiving",
    exact: true,
    isMobile: true,
    component: lazy(() => import("@screens/Receiving/Tracking/Detail")),
  },
  {
    name: "receiving.rejected-documents",
    path: "/recebimento/documentos-rejeitados",
    ability: "receiving.rejected-documents",
    exact: true,
    isMobile: true,
    component: lazy(() => import("@screens/Receiving/RejectedDocuments/index")),
  },
  {
    name: "receiving.boletos",
    path: "/recebimento/boletos",
    ability: "receiving",
    exact: true,
    isMobile: true,
    component: lazy(() => import("@screens/Receiving/Boletos/index")),
  },
  {
    name: "receiving.pre-note-failures",
    path: "/recebimento/falhas-pre-nota",
    ability: "receiving.pre-note-failures",
    exact: true,
    isMobile: true,
    component: lazy(() => import("@screens/Receiving/PreNoteFailures/index")),
  },
  {
    name: "receiving.detail",
    path: "/recebimento/:id",
    ability: "receiving",
    exact: true,
    isMobile: true,
    component: lazy(() => import("@screens/Receiving/Detail")),
    mobileComponent: lazy(() => import("@screens/Mobile/Receiving/Detail")),
  },
  {
    name: "inventory",
    path: "/inventario",
    ability: "inventory",
    exact: true,
    isMobile: true,
    component: lazy(() => import("@screens/Inventory/index")),
    mobileComponent: lazy(() => import("@screens/Mobile/Inventory/SessionList")),
  },
  {
    name: "inventory.barcode-requests",
    path: "/inventario/solicitacoes-codigo-barras",
    ability: "inventory.barcode-requests",
    exact: true,
    component: lazy(() => import("@screens/Inventory/BarcodeRequests")),
  },
  {
    name: "inventory.counting",
    path: "/inventario/:id/contagem",
    ability: "inventory",
    exact: true,
    isMobile: true,
    component: lazy(() => import("@screens/Inventory/ItemCounting")),
    mobileComponent: lazy(() => import("@screens/Mobile/Inventory/ItemCounting")),
  },
  {
    name: "inventory.summary",
    path: "/inventario/:id/resumo",
    ability: "inventory",
    exact: true,
    isMobile: true,
    component: lazy(() => import("@screens/Inventory/Summary")),
    mobileComponent: lazy(() => import("@screens/Mobile/Inventory/Summary")),
  },
  {
    name: "inventory.reclassification",
    path: "/inventario/:sessionId/reclassificacao",
    ability: "inventory.perform-reclassification",
    exact: true,
    component: lazy(() => import("@screens/Inventory/Reclassification/ReclassificationScreen")),
  },
  {
    name: "inventory.recount",
    path: "/inventario/:id/recontagem",
    ability: "inventory",
    exact: true,
    component: lazy(() => import("@screens/Inventory/SecondCount")),
  },
  {
    name: "inventory.dashboard",
    path: "/inventario/dashboard",
    ability: "inventory.dashboard",
    exact: true,
    component: lazy(() => import("@screens/Inventory/Dashboard")),
  },
  {
    name: "inventory.cyclic-counting",
    path: "/inventario/contagem-ciclica",
    ability: "inventory.cyclic-counting",
    exact: true,
    component: lazy(() => import("@screens/Inventory/CyclicCounting")),
  },
  {
    name: "stock-transfer",
    path: "/transferencia-estoque",
    ability: "stock-transfer",
    exact: true,
    isMobile: true,
    component: lazy(() => import("@screens/StockTransfer/index")),
    mobileComponent: lazy(() => import("@screens/Mobile/StockTransfer/TransferList")),
  },
  {
    name: "stock-transfer.items",
    path: "/transferencia-estoque/:id/itens",
    ability: "stock-transfer",
    exact: true,
    isMobile: true,
    component: lazy(() => import("@screens/StockTransfer/TransferItems")),
    mobileComponent: lazy(() => import("@screens/Mobile/StockTransfer/TransferItems")),
  },
  {
    name: "stock-transfer.summary",
    path: "/transferencia-estoque/:id/resumo",
    ability: "stock-transfer",
    exact: true,
    isMobile: true,
    component: lazy(() => import("@screens/StockTransfer/TransferSummary")),
    mobileComponent: lazy(() => import("@screens/Mobile/StockTransfer/TransferSummary")),
  },
  {
    name: "tickets.dashboard",
    path: "/chamados/painel",
    ability: "tickets",
    exact: true,
    component: lazy(() => import("@screens/Ticket/Dashboard")),
  },
  {
    name: "tickets.list",
    path: "/chamados/lista",
    ability: "tickets",
    exact: true,
    component: lazy(() => import("@screens/Ticket/index")),
  },
  {
    name: "tickets.detail",
    path: "/chamados/:id",
    ability: "tickets",
    exact: true,
    component: lazy(() => import("@screens/Ticket/Detail")),
  },
  {
    name: "nps.metrics",
    path: "/nps/metricas",
    ability: ["admin", "nps.metrics"],
    exact: true,
    component: lazy(() => import("@screens/NPS/NpsMetrics")),
  },
  {
    name: "nps.config",
    path: "/nps/configuracao",
    ability: ["admin", "nps.manage"],
    exact: true,
    component: lazy(() => import("@screens/NPS/index")),
  },
];

export const mobileRoutes = [
  {
    name: "mobile.select-company",
    path: "/mobile/select-company",
    ability: null,
    exact: true,
    component: lazy(() => import("@screens/Mobile/CompanySelection")),
  },
  {
    name: "mobile.home",
    path: "/mobile",
    ability: null,
    exact: true,
    component: lazy(() => import("@screens/MobileHome")),
  },
];
